import styled from 'styled-components';

import { green, whitesmoke } from 'utils/style/colors';

interface IOptionsBoxProps {
  focused: boolean;
}
export const SearchAndAddBar = styled.div`
  display: flex;
  padding: 0.5em;
  align-items: center;
  justify-content: space-between;
`;

export const OptionsBox = styled('div')<IOptionsBoxProps>`
  display: ${(props) => (props.focused ? 'block' : 'none')};
  width: 100%;
  min-width: 300px;
  max-width: ${(props) => props.maxWidth};
  background-color: var(--exact-white);
  box-shadow: ${(props) =>
    props.hasOuterBorder && '0 2px 8px rgba(0, 0, 0, 0.15)'};
  border-radius: 10px;
  margin: 5px 0 0;
  z-index: 10001;
`;

export const EditIcon = styled('span')`
  border-radius: 30px;
  background-color: ${green};
  color: white;
  margin: 3px;
  padding: 5px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;
  & > span {
    padding: 0 10px;
  }
`;

export const ItemList = styled('ul')`
  max-height: 250px;
  overflow-y: auto;
  //overflow-y: overlay;
  margin: 0;
`;

export const Option = styled('li')`
  padding: 0.5em;
  color: gray;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${whitesmoke};
`;

export const EmptyOption = styled('span')`
  margin: 0.5em;
  display: block;
  text-align: center;
  color: gray;
`;

interface IBadgeProps {
  color?: string;
}

export const Badge = styled('span')<IBadgeProps>`
  display: inline-block;
  border-radius: 10px;
  background-color: ${(props) => (props.color ? props.color : green)};
  color: white;
  padding: 2px 8px;
  cursor: pointer;
  &:hover {
    border: 1px solid #34c8b6 !important;
  }
  margin: 0 0.5em;
  font-size: 0.8em;
`;

export const Chip = styled('div')`
  display: inline-flex;
  font-size: 0.8rem;
  align-items: stretch;
  font-weight: 500;
  line-height: 2rem;
  color: #696969;
  margin: 3px;
  cursor: pointer;
  padding: 0 0.5rem;
  word-break: break-word;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: ${whitesmoke};
`;

export const ChipContainer = styled('div')`
  display: flex;
  align-items: center;
  margin: 0.5em 0;
`;

export const AddMemberWrapper = styled('div')`
  display: flex;
  padding: 10px;
  flex-direction: column;
`;

export const RolesWrapper = styled('div')`
  display: block;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  // align-items: flex-start;
  // flex-wrap: wrap;
  // flex-direction: row-reverse;
`;
